import React from "react";
import Layout from "../../components/layout";
import FlexprintMainBanner from "../../components/flexprint-case-study/page-main-banner";
import FlexprintCsIntro from "../../components/flexprint-case-study/cs-intro";
import FlexprintCsTechnology from "../../components/flexprint-case-study/cs-technology";
import FlexprintCsTestimonial from "../../components/flexprint-case-study/cs-testimonial";
import FlexprintCsAutomation from "../../components/flexprint-case-study/cs-automation";
import FlexprintCsResult from "../../components/flexprint-case-study/cs-result";
import SEO from '../../components/seo';
import FormSection from "../../components/common/templates/form/form-section";
import StickyCTA from "../../components/common/templates/sticky-cta-section";

function FlexprintCaseStudy({ location }) {

  return (
    <Layout addBodyClass="flexprint-case-study-page-template transparent-header" footerFormType="basic">
      <SEO description="How Rapidops helped FlexTG(R) improve customer services and automate processes with IoT?"
        meta={[{ name: "charSet", content: "utf-8" }]}
        title="Transforming managed - printing with digital transformation & IoT - FlexTG(R)" />
      <FlexprintMainBanner />
      <FlexprintCsIntro />
      <FlexprintCsTechnology />
      <FlexprintCsTestimonial />
      <FlexprintCsAutomation />
      <FlexprintCsResult />
      {/*<FormSection location={location} className="site-footer-form" />*/}
      {/* <StickyCTA /> */}
    </Layout>

  );
}

export default FlexprintCaseStudy;
